import Component from './component';

export interface Props {
    section: {
        description?: string;
        title?: string;
    }
}

export default Component;
